import { render, staticRenderFns } from "./NotifyMe.vue?vue&type=template&id=2872b068&scoped=true"
import script from "./NotifyMe.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotifyMe.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NotifyMe.vue?vue&type=style&index=0&id=2872b068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2872b068",
  null
  
)

export default component.exports